

















































































import { Component, Vue } from "vue-property-decorator";
import { General } from "@/services/General";
import { HubConnectionBuilder } from "@microsoft/signalr";
import {Process} from '@/entity/Process';

@Component
export default class UserProcess extends Vue {
    processList: Array<Process> = [];
    otherProcessList: any = [];
    connection: any = null;

    created() {
        this.connection = new HubConnectionBuilder()
            .withUrl(General.GetApiUrl('/message'))
            .build();

        this.connection.start();
    }

    mounted() {

        
        this.processList = this.$store.getters.getProcessList;

        this.connection.on("status", data => {                   
            var dataParsed = JSON.parse(data);
            this.otherProcessList = dataParsed.filter(process => process.Username !== this.$store.state.user.Username);
            
        });

    
    }

    beforeDestroy() {
        this.connection.stop();
    }

    deleteProcess(processId: string) {
        this.$store.commit("DELETE_PROCESS",processId);
        this.processList = this.$store.getters.getProcessList;
    }

    deleteAllProcess() {
        this.$store.commit("CLEAR_PROCESS_LIST");
        this.processList = this.$store.getters.getProcessList;
    }

    closeDetailModal() {
        this.$bvModal.hide("user-process-modal");
    }
    formatDate(date){
        if (date==null) return '';
        return General.showDate( date);

    }
    
}
